// @ts-nocheck
import * as React from "react";
import { Ic, PasswordInput, apiErrorMessage, siteName, brandParts } from "./common";

// 비밀번호 만료 강제 변경 화면.
// 로그인 시 비밀번호가 만료된(security.password_max_age_days 초과) 사용자는 서버가
// must_change_password 플래그를 내려 이 화면으로 보낸다. 변경 전까지 다른 모든 API/화면은
// 막혀 있다(BaseController.gate_password_change! · DesignController.gate_password_change_screen).
// 기존 self-service 엔드포인트(PATCH /api/v1/users/me/password)를 그대로 재사용한다 —
// 현재 비밀번호 확인 + 정책 검증을 서버가 담당하고, 성공 시 password_changed_at 갱신으로
// 만료가 자동 해제된다.
function PasswordChange() {
  const [cur, setCur]   = React.useState("");
  const [pw, setPw]     = React.useState("");
  const [pw2, setPw2]   = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [err, setErr]   = React.useState(null);
  const [done, setDone] = React.useState(false);

  const submit = async (e) => {
    if (e) e.preventDefault();
    setErr(null);
    if (pw !== pw2) { setErr("새 비밀번호가 일치하지 않습니다."); return; }
    if (pw.length < 6) { setErr("비밀번호는 최소 6자 이상이어야 합니다."); return; }
    if (pw === cur) { setErr("이전과 다른 새 비밀번호를 입력해주세요."); return; }
    setSubmitting(true);
    try {
      const r = await fetch("/api/v1/users/me/password", {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ current_password: cur, password: pw, password_confirmation: pw2 }),
      });
      if (!r.ok) {
        const j = await r.json().catch(() => ({}));
        setErr(apiErrorMessage(j, r.status));
        return;
      }
      setDone(true);
      // 변경 성공 → 만료 해제됨. 역할별 기본 화면으로 이동.
      let dest = "/";
      try {
        const me = await fetch("/api/v1/sessions/me", { credentials: "same-origin" });
        if (me.ok) { const u = await me.json(); dest = u.default_path || "/"; }
      } catch { /* 폴백 / */ }
      window.location.href = dest;
    } catch (e) { setErr(apiErrorMessage(e)); } finally { setSubmitting(false); }
  };

  return (
    <div className="app" style={{display:'grid', gridTemplateColumns:'1fr 1fr', height:'100%', background:'var(--bg)'}}>
      <div style={{padding:'48px 56px', background:'linear-gradient(160deg, #2A241F 0%, #3F342C 60%, #5A4434 100%)', color:'#F5EBD8', position:'relative', overflow:'hidden', display:'flex', flexDirection:'column'}}>
        <a href="/" style={{display:'flex', alignItems:'center', gap:10, color:'inherit', textDecoration:'none'}}>
          <div className="brand-mark" style={{width:32, height:32}}>{brandParts(siteName()).mark}</div>
          <div>
            <div style={{fontWeight:800, fontSize:15, color:'#fff'}}>{brandParts(siteName()).name}</div>
            {brandParts(siteName()).sub && <div style={{fontSize:10, color:'#A89A7C', letterSpacing:'0.06em'}}>{brandParts(siteName()).sub}</div>}
          </div>
        </a>

        <div style={{marginTop:60}}>
          <div style={{fontSize:11, color:'var(--orange-300)', fontWeight:700, letterSpacing:'0.08em', marginBottom:14}}>비밀번호 만료</div>
          <h1 style={{fontSize:36, fontWeight:800, lineHeight:1.25, letterSpacing:'-0.02em', margin:0, color:'#fff'}}>
            보안을 위해<br/>비밀번호를 변경해주세요.
          </h1>
          <p style={{fontSize:14, lineHeight:1.7, color:'#D4C9B2', marginTop:18, maxWidth:380}}>
            비밀번호 사용 기간이 만료되었습니다. 새 비밀번호로 변경하면 바로 이어서 이용하실 수 있습니다.
            최소 6자, 영문과 숫자를 모두 포함해야 합니다.
          </p>
        </div>
      </div>

      <form onSubmit={submit} style={{padding:'48px 56px', display:'flex', flexDirection:'column', overflow:'auto'}}>
        <div style={{margin:'52px 0 28px'}}>
          <h2 style={{fontSize:28, fontWeight:800, letterSpacing:'-0.02em', margin:0}}>새 비밀번호 설정</h2>
          <p style={{color:'var(--ink-3)', fontSize:13, marginTop:8}}>현재 비밀번호를 확인한 뒤 새 비밀번호를 입력해주세요.</p>
        </div>

        {err && <div style={{padding:'10px 14px', background:'var(--rose-50)', color:'var(--rose-500)', borderRadius:10, fontSize:12.5, marginBottom:14}}>{err}</div>}

        <div className="label">현재 비밀번호</div>
        <PasswordInput autoComplete="current-password" required
          value={cur} onChange={e=>setCur(e.target.value)} placeholder="현재(만료된) 비밀번호" style={{marginBottom:14}}/>

        <div className="label">새 비밀번호</div>
        <PasswordInput autoComplete="new-password" required minLength={6}
          value={pw} onChange={e=>setPw(e.target.value)} placeholder="최소 6자, 영문+숫자" style={{marginBottom:14}}/>

        <div className="label">새 비밀번호 확인</div>
        <PasswordInput autoComplete="new-password" required minLength={6}
          value={pw2} onChange={e=>setPw2(e.target.value)} placeholder="다시 한 번 입력" style={{marginBottom:14}}/>

        <button type="submit" disabled={submitting || done || !cur || !pw || !pw2} className="btn btn-primary btn-lg" style={{marginTop:8, width:'100%'}}>
          {submitting || done ? '변경 중…' : '비밀번호 변경하고 계속 →'}
        </button>

        <div style={{marginTop:18, textAlign:'center', fontSize:12, color:'var(--ink-3)'}}>
          <a href="/api/v1/sessions" onClick={(e)=>{ e.preventDefault(); fetch("/api/v1/sessions",{method:"DELETE",credentials:"same-origin"}).finally(()=>window.location.href="/login"); }}
             style={{color:'var(--orange-600)', fontWeight:700, textDecoration:'none'}}>로그아웃</a>
        </div>
      </form>
    </div>
  );
}

export { PasswordChange };
